import { useContext } from 'react';
import { useMutation } from '@apollo/client';
import { SnackbarContext } from '../contexts';

import { clientContextWarn, graphQLErrorMessages } from '../utils';

const useEnhancedMutation = (query, options = {}) => {
  const snackbarContext = useContext(SnackbarContext);
  const { setOpenSnackbar } = snackbarContext.actions;

  const handleOnError = (err) => {
    let msg = err.message || 'An error occurred. Please try again.';
    // Surface the resolver's own message, capitalised, when there is one.
    const [resolverMessage] = Array.isArray(err.graphQLErrors) && err.graphQLErrors.length > 0
      ? graphQLErrorMessages(err)
      : [];
    if (resolverMessage) {
      msg = resolverMessage.charAt(0).toUpperCase() + resolverMessage.slice(1);
    }
    if (options.customErrorMessage) {
      msg = options.customErrorMessage(err, msg);
    }
    if (!options.disableDefaultError) {
      setOpenSnackbar({
        variant: 'error',
        message: msg,
      });
    }
    clientContextWarn(err);
    if (options && options.onError) {
      options.onError(err);
    }
  };

  const result = useMutation(query, {
    ...options,
    onError: handleOnError,
  });

  return result;
};

export default useEnhancedMutation;
